// Config reducer actions
export const ACTION_LOAD_CONFIG = "ACTION_LOAD_CONFIG";

// Chat reducer actions
export const ACTION_CHANGE_EXPANDED_STATUS = "ACTION_CHANGE_EXPANDED_STATUS";
export const ACTION_CHANGE_ENGAGEMENT_PHASE = "ACTION_CHANGE_ENGAGEMENT_PHASE";
export const ACTION_START_SESSION = "ACTION_START_SESSION";
/*
 * Solta a conversa ENCERRADA do estado ao iniciar uma nova. Sem isto, `chat.conversation` seguia
 * apontando pra conversa morta enquanto o cliente preenchia o formulário — e enviar pra ela é
 * exatamente o que devolve 400 (diagnóstico de 2026-08-28).
 */
export const ACTION_RESET_CONVERSATION = "ACTION_RESET_CONVERSATION";
export const ACTION_UPDATE_PARTICIPANT = "ACTION_UPDATE_PARTICIPANT";
export const ACTION_ADD_PARTICIPANT = "ACTION_ADD_PARTICIPANT";
export const ACTION_REMOVE_PARTICIPANT = "ACTION_REMOVE_PARTICIPANT";
export const ACTION_UPDATE_MESSAGE = "ACTION_UPDATE_MESSAGE";
export const ACTION_ADD_MESSAGE = "ACTION_ADD_MESSAGE";
export const ACTION_REMOVE_MESSAGE = "ACTION_REMOVE_MESSAGE";
export const ACTION_ADD_MULTIPLE_MESSAGES = "ACTION_ADD_MULTIPLE_MESSAGES";
export const ACTION_ATTACH_FILES = "ACTION_ATTACH_FILES";
export const ACTION_DETACH_FILES = "ACTION_DETACH_FILES";
export const ACTION_UPDATE_CONVERSATION_STATE = "ACTION_UPDATE_CONVERSATION_STATE";
export const ACTION_UPDATE_AWAITING_BOT = "ACTION_UPDATE_AWAITING_BOT";
export const ACTION_UPDATE_HUMAN_MODE = "ACTION_UPDATE_HUMAN_MODE";
export const ACTION_UPDATE_AGENT_TYPING = "ACTION_UPDATE_AGENT_TYPING";
export const ACTION_UPDATE_CSAT_PENDING = "ACTION_UPDATE_CSAT_PENDING";
export const ACTION_UPDATE_CSAT = "ACTION_UPDATE_CSAT";
export const ACTION_UPDATE_WELCOME_INPUT_LOCK = "ACTION_UPDATE_WELCOME_INPUT_LOCK";
export const ACTION_UPDATE_SESSION_DATA = "ACTION_UPDATE_SESSION_DATA";
export const ACTION_UPDATE_PRE_ENGAGEMENT_DATA = "ACTION_UPDATE_PRE_ENGAGEMENT_DATA";
export const ACTION_UPDATE_PRE_ENGAGEMENT_STEP = "ACTION_UPDATE_PRE_ENGAGEMENT_STEP";

// Notification reducer actions
export const ACTION_ADD_NOTIFICATION = "ACTION_ADD_NOTIFICATION";
export const ACTION_REMOVE_NOTIFICATION = "ACTION_REMOVE_NOTIFICATION";
